import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { Store } from 'src/redux/Store';
import AddInvoiceButton from 'src/components/Control/Buttons/AddInvoiceButton';
import ViewInvoiceButton from 'src/components/Control/Buttons/ViewInvoiceButton';
import EditInvoiceButton from 'src/components/Control/Buttons/EditInvoiceButton';
import DownloadInvoiceButton from 'src/components/Control/Buttons/DownloadInvoiceButton';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import MakePaymentButton from 'src/components/Control/Buttons/MakePaymentButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import ShowPaymentsForInvoiceButton
  from 'src/components/Control/Buttons/ShowPaymentsForInvoiceButton';
import { keyBy } from 'lodash';
import { INVOICE_PAYMENT_STATUS, INVOICE_STATE } from 'src/constants/Invoices';
import DeleteInvoiceButton from 'src/components/Control/Buttons/DeleteInvoiceButton';
import MakeRecurringButton from 'src/components/Control/Buttons/MakeRecurringButton';

const InvoiceToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.invoices] || [],
  );
  const invoices = useSelector(
    (state: Store) => (
      (!!state.querybuilder.invoices && !!state.querybuilder.invoices.result)
        ? keyBy(state.querybuilder.invoices.result.list, 'invoices.id') : []
    ),
  );

  const [disablePaymentState, setDisablePaymentState] = useState(false);

  useEffect(() => {
    let shouldDisable = false;

    if (!selections.length) {
      setDisablePaymentState(true);
      return;
    }

    selections.forEach((invoiceId: number) => {
      if (!!invoices[invoiceId] && !!invoices[invoiceId]['invoices.payment_status']) {
        if (invoices[invoiceId]['invoices.payment_status'] === INVOICE_PAYMENT_STATUS.paid) {
          shouldDisable = true;
        }
        if (
          invoices[invoiceId]['invoices.state'] === INVOICE_STATE.draft
          || invoices[invoiceId]['invoices.state'] === INVOICE_STATE.template
        ) {
          shouldDisable = true;
        }
      }

      setDisablePaymentState(shouldDisable);
    });
  }, [selections]);

  return (
    <>
      <DeleteInvoiceButton
        disabled={!selections.length || selections.length > 1}
        invoiceId={selections[0]} />
      <AddInvoiceButton />
      <EditInvoiceButton
        disabled={!selections.length} />
      <ViewInvoiceButton
        disabled={!selections.length} />
      <MakePaymentButton
        disabled={disablePaymentState} />
      <MakeRecurringButton
        invoiceId={selections[0]}
        disabled={
          !selections.length
          || selections.length > 1
          || (!!invoices[selections[0]] && invoices[selections[0]]['invoices.state'] === INVOICE_STATE.template)
        } />
      <ConfigureColumnsButton
        entity={ENTITIES.invoices} />
      <UnselectAllMenubutton
        entity={ENTITIES.invoices}
        disabled={!selections.length} />
      <ShowPaymentsForInvoiceButton
        invoiceId={selections[0]}
        disabled={(!selections.length || selections.length > 1)} />
      <DownloadInvoiceButton />
    </>
  );
};
export default InvoiceToolbar;
